<!-- eslint-disable vue/no-mutating-props, vue/no-multiple-template-root, no-undef -->
<template>
  <transition
    name="custom-transition"
    enter-active-class="animate__animated animate__backInLeft"
    leave-active-class="animate__animated animate__backOutLeft"
  >
    <button
      v-show="!menuPanel && isMobile"
      id="btn-back-to-top"
      type="button"
      class="btn btn-danger btn-floating btn-lg menu-open"
      @click="menuPanelTrigger"
    >
      Show Menu
    </button>
  </transition>
  <!-- Desktop menü -->
  <div
    v-if="!isMobile"
    class="col-md-3"
  >
    <div
      class="fixed-bar fl-wrap"
      style="z-index: auto; height: 100%; position: relative; top: 0px"
    >
      <div class="user-profile-menu-wrap fl-wrap">
        <!-- user-profile-menu-->
        <div class="user-profile-menu">
          <h3
            v-show="isMobile"
            style="cursor: pointer; float: right"
            @click="menuPanelTrigger"
          >
            Close Menu
          </h3>
          <ul>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ 'user-profile-act': activeTab === 'dashboard' }"
                @click.prevent="$emit('change-tab', 'dashboard')"
              >
                <i class="fas fa-regular fa-gears" />
                Dashboard
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ 'user-profile-act': activeTab === 'aiConversations' }"
                @click.prevent="$emit('change-tab', 'aiConversations')"
              >
                <i class="fas fa-regular fa-robot" />
                AI Conversations
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ 'user-profile-act': activeTab === 'editProfile' }"
                @click.prevent="$emit('change-tab', 'editProfile')"
              >
                <i class="fas fa-regular fa-user" />
                Profile Settings
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ 'user-profile-act': activeTab === 'editCompany' }"
                @click.prevent="$emit('change-tab', 'editCompany')"
              >
                <i class="fas fa-regular fa-user" />
                Company / Services Settings
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                @click.prevent="goToChat"
              ><i class="fas fa-regular fa-envelope" /> Messages
                <span> {{ unreadCount }} </span></a>
            </li>
          </ul>
        </div>
        <!-- user-profile-menu end-->
        <!-- user-profile-menu-->
        <div class="user-profile-menu">
          <h3>Listings</h3>
          <ul>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ 'user-profile-act': activeTab === 'myListing' }"
                @click.prevent="$emit('change-tab', 'myListing')"
              >
                <i class="fas fa-regular fa-th-list" /> My listings
              </a>
            </li>
            <li>
              <router-link to="/add-listing">
                <a href="javascript:void(0)"><i class="fas fa-regular fa-plus-square" /> Add New</a>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- user-profile-menu end-->
        <a
          href="javascript:void(0)"
          class="log-out-btn"
          @click="$emit('logout')"
        >Log Out</a>
      </div>
    </div>
  </div>

  <!-- Mobil menü -->
  <transition
    v-else
    name="custom-transition"
    enter-active-class="animate__animated animate__backInLeft"
    leave-active-class="animate__animated animate__backOutLeft"
  >
    <div
      v-if="menuPanel"
      class="col-md-3"
      :class="menuPanelClasses"
    >
      <div
        class="fixed-bar fl-wrap"
        style="z-index: auto; height: 100%; position: relative; top: 0px"
      >
        <div class="user-profile-menu-wrap fl-wrap">
          <!-- user-profile-menu-->
          <div class="user-profile-menu">
            <h3
              style="cursor: pointer; float: right"
              @click="menuPanelTrigger"
            >
              Close Menu
            </h3>
            <ul>
              <li>
                <a
                  href="javascript:void(0)"
                  :class="{ 'user-profile-act': activeTab === 'dashboard' }"
                  @click.prevent="handleMobileTabClick('dashboard')"
                >
                  <i class="fas fa-regular fa-gears" />
                  Dashboard
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0)"
                  :class="{ 'user-profile-act': activeTab === 'aiConversations' }"
                  @click.prevent="handleMobileTabClick('aiConversations')"
                >
                  <i class="fas fa-regular fa-robot" />
                  AI Conversations
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0)"
                  :class="{ 'user-profile-act': activeTab === 'editProfile' }"
                  @click.prevent="handleMobileTabClick('editProfile')"
                >
                  <i class="fas fa-regular fa-user" />
                  Profile Settings
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0)"
                  :class="{ 'user-profile-act': activeTab === 'editCompany' }"
                  @click.prevent="handleMobileTabClick('editCompany')"
                >
                  <i class="fas fa-regular fa-user" />
                  Company / Services Settings
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0)"
                  @click.prevent="handleMobileChatClick"
                ><i class="fas fa-regular fa-envelope" /> Messages
                  <span> {{ unreadCount }} </span></a>
              </li>
            </ul>
          </div>
          <!-- user-profile-menu end-->
          <!-- user-profile-menu-->
          <div class="user-profile-menu">
            <h3>Listings</h3>
            <ul>
              <li>
                <a
                  href="javascript:void(0)"
                  :class="{ 'user-profile-act': activeTab === 'myListing' }"
                  @click.prevent="handleMobileTabClick('myListing')"
                >
                  <i class="fas fa-regular fa-th-list" /> My listings
                </a>
              </li>
              <li>
                <router-link
                  to="/add-listing"
                  @click="closeMobileMenu"
                >
                  <a href="javascript:void(0)"><i class="fas fa-regular fa-plus-square" /> Add New</a>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- user-profile-menu end-->
          <a
            href="javascript:void(0)"
            class="log-out-btn"
            @click="handleMobileLogout"
          >Log Out</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, defineProps, defineEmits } from 'vue';
import { useRouter } from 'vue-router';

defineProps({
  activeTab: {
    type: String,
    required: true
  },
  unreadCount: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['change-tab', 'logout']);
const router = useRouter();

const menuPanel = ref(true);
const isMobile = ref(window.innerWidth < 920);

const menuPanelClasses = computed(() => {
  return [
    menuPanel.value ? 'animate__backInLeft' : 'animate__backOutLeft',
    isMobile.value ? 'mobil-fix' : '',
  ];
});

const checkMobile = () => {
  isMobile.value = window.innerWidth < 920;
};

const menuPanelTrigger = () => {
  menuPanel.value = !menuPanel.value;
};

const goToChat = () => {
  router.push('/chat');
};

const closeMobileMenu = () => {
  if (isMobile.value) {
    menuPanel.value = false;
  }
};

const handleMobileTabClick = (tab) => {
  emit('change-tab', tab);
  closeMobileMenu();
};

const handleMobileChatClick = () => {
  goToChat();
  closeMobileMenu();
};

const handleMobileLogout = () => {
  emit('logout');
  closeMobileMenu();
};

onMounted(() => {
  window.addEventListener('resize', checkMobile);
  setTimeout(() => {
    menuPanelTrigger(); // Emulate the original behavior where it toggles after a delay
  }, 800);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});
</script>


